import type { O5AwsDeployerV1StackKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../util/routing/entity-paths';

export const O5_STACK_BASE_PATH = getResolvedPath('/tech-ops/stack');

export const getO5StackPath: EntityPathBuilder<O5AwsDeployerV1StackKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return O5_STACK_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.stackId) {
        return undefined;
      }

      return getResolvedPath(`${O5_STACK_BASE_PATH}/$stackId`, context?.keys);
    }
  }
};

export function getO5StackDetailPath(stackId: string | undefined) {
  if (!stackId) {
    return undefined;
  }

  return getO5StackPath({ kind: 'detail', keys: { stackId } });
}
